import { createApp } from "vue";
import App from "./App.vue";
// import "./registerSergitviceWorker";
import router from "./router";
import store from "./store";
import mixin from "./mixins/device";

createApp(App).use(store).use(router).mixin(mixin).mount("#app");
